<div>
  <!-- Toast notifications -->
  <p-toast position="top-right"></p-toast>

  <!-- Page Header -->
  <div class="mb-6">
    <h1 class="text-heading-xl mb-2">
      {{
        isEditMode
          ? ('projectOwnerEdit.titleEdit' | translate)
          : ('projectOwnerEdit.titleAdd' | translate)
      }}
    </h1>
    <p class="text-body-md text-secondary">
      {{
        isEditMode
          ? ('projectOwnerEdit.subtitleEdit' | translate)
          : ('projectOwnerEdit.subtitleAdd' | translate)
      }}
    </p>
  </div>

  <!-- Project Owner Form -->
  <div class="max-w-2xl">
    <p-card>
      <form [formGroup]="userForm" (ngSubmit)="onSubmit()" class="flex flex-col gap-6">
        <!-- Email Field -->
        <div class="flex flex-col gap-2">
          <label for="email" class="text-label-md">{{
            'projectOwnerEdit.email' | translate
          }}</label>
          @if (loading()) {
          <p-skeleton width="100%" height="2.5rem"></p-skeleton>
          } @else {
          <input
            id="email"
            type="email"
            pInputText
            [formControl]="emailControl"
            [placeholder]="'projectOwnerEdit.emailPlaceholder' | translate"
            autocomplete="off"
            class="w-full"
          />
          @if (emailControl.invalid && emailControl.touched) {
          <p-message severity="error">
            {{ getEmailErrorMessage() }}
          </p-message>
          } }
        </div>

        <!-- Password Field (Create Mode Only) -->
        @if (!isEditMode) {
        <div class="flex flex-col gap-2">
          <label for="password" class="text-label-md">{{
            'projectOwnerEdit.password' | translate
          }}</label>
          <input
            id="password"
            type="password"
            pInputText
            [formControl]="passwordControl"
            [placeholder]="'projectOwnerEdit.passwordPlaceholder' | translate"
            autocomplete="new-password"
            class="w-full"
          />
          @if (passwordControl.invalid && passwordControl.touched) {
          <p-message severity="error">
            {{ getPasswordErrorMessage() }}
          </p-message>
          }
        </div>
        }

        <!-- Full Name Field -->
        <div class="flex flex-col gap-2">
          <label for="fullName" class="text-label-md">{{
            'projectOwnerEdit.fullName' | translate
          }}</label>
          @if (loading()) {
          <p-skeleton width="100%" height="2.5rem"></p-skeleton>
          } @else {
          <input
            id="fullName"
            type="text"
            pInputText
            [formControl]="fullNameControl"
            [placeholder]="'projectOwnerEdit.fullNamePlaceholder' | translate"
            autocomplete="off"
            class="w-full"
          />
          }
        </div>

        <!-- Company Field -->
        <div class="flex flex-col gap-2">
          <label for="company" class="text-label-md">{{
            'projectOwnerEdit.company' | translate
          }}</label>
          @if (loading()) {
          <p-skeleton width="100%" height="2.5rem"></p-skeleton>
          } @else {
          <input
            id="company"
            type="text"
            pInputText
            [formControl]="companyControl"
            [placeholder]="'projectOwnerEdit.companyPlaceholder' | translate"
            autocomplete="off"
            class="w-full"
          />
          }
        </div>

        <!-- Form Actions -->
        <div class="flex flex-col sm:flex-row gap-3 pt-4">
          @if (loading()) {
          <p-skeleton width="8rem" height="2.5rem"></p-skeleton>
          <p-skeleton width="8rem" height="2.5rem"></p-skeleton>
          } @else {
          <p-button
            type="submit"
            [label]="
              submitting()
                ? isEditMode
                  ? ('projectOwnerEdit.saving' | translate)
                  : ('projectOwnerEdit.creating' | translate)
                : isEditMode
                ? ('projectOwnerEdit.save' | translate)
                : ('projectOwnerEdit.create' | translate)
            "
            [icon]="
              submitting() ? 'pi pi-spin pi-spinner' : isEditMode ? 'pi pi-save' : 'pi pi-plus'
            "
            [disabled]="userForm.invalid || submitting()"
            [loading]="submitting()"
            class="flex-1 sm:flex-initial"
          />
          <p-button
            type="button"
            [label]="'projectOwnerEdit.cancel' | translate"
            severity="secondary"
            [outlined]="true"
            [disabled]="submitting()"
            (onClick)="onCancel()"
            class="flex-1 sm:flex-initial"
          />
          }
        </div>
      </form>
    </p-card>
  </div>

  <!-- Projects Table (only in edit mode when projects exist) -->
  @if (isEditMode && ownerProjects().length > 0) {
  <div class="max-w-2xl mt-6">
    <p-card>
      <div class="flex flex-col gap-4">
        <h3 class="text-heading-md">
          {{ 'projectOwnerEdit.projectsTitle' | translate }}
        </h3>
        <p-table
          [value]="ownerProjects()"
          [tableStyle]="{ 'min-width': '100%' }"
          [stripedRows]="true"
          styleClass="p-datatable-sm"
        >
          <ng-template pTemplate="body" let-project>
            <tr>
              <td>
                <span class="text-body-sm">{{ project.name }}</span>
              </td>
              <td style="width: 60px">
                <div class="flex gap-2">
                  <p-button
                    icon="pi pi-arrow-right"
                    [rounded]="true"
                    size="small"
                    [ariaLabel]="'projectOwnerEdit.viewProjectDetails' | translate"
                    (onClick)="openProjectDetails(project.id)"
                  />
                </div>
              </td>
            </tr>
          </ng-template>

          <!-- Empty state -->
          <ng-template pTemplate="emptymessage">
            <tr>
              <td colspan="2" class="text-center py-8">
                <div class="flex flex-col items-center gap-3">
                  <i class="pi pi-inbox text-4xl text-muted"></i>
                  <p class="text-body-md text-muted">
                    {{ 'projectOwnerEdit.noProjects' | translate }}
                  </p>
                </div>
              </td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </p-card>
  </div>
  }
</div>
